import { render, staticRenderFns } from "./ObservationDetails.vue?vue&type=template&id=4a0147b4&"
import script from "./ObservationDetails.vue?vue&type=script&lang=js&"
export * from "./ObservationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ObservationDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports